export const orderDetails = {
  header: "Bestellung nachverfolgen",
  quote: "Angebot",
  subHeader: "Details zur Bestellung",
  hasBeenShipped: "Dieser Auftrag wurde bereits abgeschlossen",
  orderSummary: "Bestellübersicht",
  labels: {
    address: "Adresse",
    amountTotal: "Zahlungsbetrag Gesamt",
    billingAddress: "Rechungsadresse",
    cartSum: "Summe",
    city: "Ort",
    country: "Land",
    createdAt: "Bestelldatum",
    deliveryAndProductionTime: "Voraussichtl. Gesamtlieferzeit",
    deliveryAndProductionTimeShort: "Gesamtlieferzeit",
    deliveryDay: "Voraussichtl. Liefertermin",
    deliveryTime: "vorraussichtliche Lieferzeit",
    deliveryTimeShort: "Voraussichtl. Versandzeit",
    email: "E-Mail",
    items: "Bestellpositionen",
    name: "Name",
    net: "netto",
    orderNumber: "Auftragsnummer",
    orderStatus: "Bestellstatus",
    payment: "Bezahlung",
    paymentMethod: "Zahlungsmethode",
    positionPrice: "Gesamtpreis (ohne Versand)",
    productionTime: "Produktionszeit",
    quoteCreatedAt: "Angefragt",
    quoteNumber: "Angebotsnummer",
    shippingAddress: "Lieferadresse",
    shippingMethod: "Versand",
    shippingPrice: "Versandkosten",
    summary: "Zusammenfassung",
    summaryCaps: "ZUSAMMENFASSUNG",
  },
  businessDays: "0 Arbeitstage | 1 Arbeitstag | {n} Arbeitstage ",
  regularDays: "0 Tage | 1 Tag | {n} Tage ",
  actions: {
    reOrder: "Erneut bestellen",
    payNow: "Jetzt zahlen",
    orderNow: "Jetzt beauftragen",
  },
  reOrderModal: {
    headline: "Auftrag {orderNumber} erneut Bestellen?",
    nItems: "0 Teile | Ein Bauteil | {n} Bauteile",
  },
};
